import Router from "./router/Router";
import { Suspense, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUserData } from "./redux/slices/userSlice";
import ImageLoader from "./component/common/ImageLoader";
function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    try {
      const userData = localStorage.getItem("userData");
      if (userData) {
        dispatch(setUserData(JSON.parse(userData)));
      }
    } catch (error) {
      console.error("Error initializing user data:", error);
    }
  }, [dispatch]);

  return (
    <Suspense fallback={
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '16px',
        color: '#666'
      }}>
        <ImageLoader/>
      </div>
    }>
      <Router />
    </Suspense>
  );
}

export default App;
